// Lightweight GA4 event helpers.
// Safe to call before gtag is ready — silently no-ops.

export function trackEvent(name, params = {}) {
  if (typeof window === "undefined") return;
  if (typeof window.gtag !== "function") return;
  try {
    window.gtag("event", name, params);
  } catch (_) {
    // Swallow analytics errors so they never break the UI.
  }
}

/**
 * Track a SPIRIT outbound click.
 *
 *   source: "home" | "intelligence" | "genetics" | "resource:<slug-or-id>"
 *   location: "primary_cta" | "header_badge" | "inline_callout" | etc.
 */
export function trackSpiritClick(source, location = "primary_cta") {
  trackEvent("spirit_outbound_click", {
    source,
    location,
    destination: "https://seedkeepers.app",
  });
}

/**
 * Track a SeedKeepers Academy outbound click.
 *
 *   source: "home" | "training" | "footer" | etc.
 *   location: "primary_cta" | "pathway_cta" | "community_cta" | etc.
 */
export function trackAcademyClick(source, location = "primary_cta") {
  trackEvent("academy_outbound_click", {
    source,
    location,
    destination: "https://seedkeepersacademy.com",
  });
}
